import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CompanyPOSubscription } from '../interfaces/po-subscriptions';
import { Subscription, SubscriptionSummary } from '../interfaces/subscription';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionAdapter {
  private http = inject(HttpClient);

  getSubscription(): Observable<Subscription> {
    return this.http.get<Subscription>(`${environment.apiBaseUrl}/company/subscription`);
  }

  getSubscriptionSummary(): Observable<SubscriptionSummary> {
    return this.http.get<SubscriptionSummary>(`${environment.apiBaseUrl}/company/subscription`);
  }

  getPONumbers(): Observable<CompanyPOSubscription[]> {
    return this.http.get<CompanyPOSubscription[]>(`${environment.apiBaseUrl}/company/po-numbers`);
  }
}
